import _ from 'lodash'
import Cookie from 'js-cookie'
import api from '../api'
import * as types from './../types'
import config from './../../config'

// 其实可以考虑按代码职责进一步拆分的，比如弹窗逻辑拆成一个单独的文件塞进common文件夹
export default {
  state: {
    // config,
    ajaxBaseUrl: config.ajaxBaseUrl,
    imageSrcPrefix: config.imageSrcPrefix,
    isFullScreenLoading: false,
    companyInfo: {},
    userInfo: {},
    aboutUsData: {},
    isEnableCreditQuotaSwitchs: false   // 是否启用额度开关
  },
  getters: {
    [types.GET_AJAX_BASE_URL]: state => state.ajaxBaseUrl,
    [types.GET_IMAGE_SRC_PREFIX]: state => state.imageSrcPrefix,
    [types.GET_COMPANY_INFO]: state => state.companyInfo,
    [types.GET_ABOUT_US_DATA]: state => state.aboutUsData,
    [types.GET_FULL_SCREEN_LOADING_STATE]: state => state.isFullScreenLoading,
    [types.GET_USER]: state => state.userInfo,
    [types.IS_LOGIN]: state => !_.isEmpty(state.userInfo),
    [types.IS_USEING_LIMIT]: state => state.isEnableCreditQuotaSwitchs
  },
  actions: {
    [types.GET_INDEX_INFO]: ({dispatch, commit}) => api.getIndexInfo().then((res) => {
      const resData = res.data
      const result = res.data.data
      document.title = result.productNameCN
      if (Number(resData.code) === 0) {
        commit(types.SET_INDEX_CAROUSEL, result.bannerFileIds)
        commit(types.SET_COMPANY_INFO, result)
        commit(types.SET_HOT_PRODUCTS, result.hotProductList.slice(0, 4))
        commit(types.SET_CONTRACT_STATE, {
          title: '温馨提示',
          show: false,
          content: result.signTips
        })
      } else {
        dispatch(types.SET_FAIL_MESSAGE, {
          show: true,
          content: resData.result || '首页信息获取错误'
        })
      }
    }),
    [types.GET_ABOUT_US] ({dispatch, commit}) {
      return api.getAboutUsInfo().then((res) => {
        if (Number(res.data.code) === 0) {
          commit(types.SET_ABOUT_US, res)
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: res.data.result || '关于我们信息获取错误'
          })
        }
      })
    },
    [types.GET_ENABLE_CREDIT_QUOTA_SWITCH]: ({dispatch, commit}) => api.getEnableCreditQuotaSwitch().then((res) => {
      commit(types.SET_ENABLE_CREDIT_QUOTA_SWITCH, res.data.result)
    }),
    [types.GET_GENERATE_RSA_PUBLIC_KEY]: ({commit}) => api.generateRSAPublicKey()
  },
  mutations: {
    [types.EMPTY_MUTATION] (state, params) {},
    [types.SET_ENABLE_CREDIT_QUOTA_SWITCH] (state, data) {
      state.isEnableCreditQuotaSwitchs = data
    },
    [types.SET_COMPANY_INFO] (state, data) {
      const friendlyLink = []
      data.partnerFileIds.forEach((item, i) => {
        friendlyLink.push({
          id: item,
          imgSrc: `${state.imageSrcPrefix}${item}`,
          url: data.partnerUrls[i]
        })
      })

      // 不适当扁平化，在渲染过程中会报错但是不影响运行，渲染初始值时候的锅？
      state.companyInfo = {
        fullChnName: data.productFullNameCN,
        fullEngName: data.productFullName,
        shortChnName: data.productNameCN,
        shortEngName: data.productName,
        name: data.pageFoot,
        tel: data.serviceNumber,
        logo: `${state.imageSrcPrefix}${data.logo}`,
        signTips: data.signTips,
        aboutCompany: data.aboutCompany.replace(/style="[^"]*?"|(\s)*/g, '').replace(/<br \/>/g, '<p/>'),
        friendlyLink
      }
    },
    [types.SET_USER] (state, data) {
      state.userInfo = data

      // 刷新时候可以重新载入store，在路由里面也可以拿出来判断，路由无法访问store
      Cookie.set('userData', encodeURIComponent(JSON.stringify(data)))
    },
    [types.SET_FULL_SCREEN_LOADING_STATE] (state, data) {
      state.isFullScreenLoading = data.isFullScreenLoading
    },
    [types.SET_ABOUT_US] (state, data) {
      state.aboutUsData = data.data.data
    },
    [types.SET_CONTRACT_STATE] (state, data) {
      state.contract = {
        title: _.isEmpty(data.title) ? state.contract.title : data.title,
        show: data.show,
        content: _.isEmpty(data.content) ? state.contract.content : data.content
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/common.js